import "./administration.scss";
import {  Container } from "react-bootstrap";
import { AddNewContact } from "../saved-contact/add-new-contact";
import { AccountUser } from "./account-users";
import { useEffect, useState } from "react";
import { apiPost } from "../../../../services/service";
import { toast } from "react-toastify";
import Loader from "../../shared-components/loader/loader";
import { POST_PROFILE_PAGE_LOAD } from "../../../../services";
import { allOptionForDropdown } from "../../../../utils";
import { Trans,useTranslation } from "react-i18next";
export const Administration = () => {
  const [progress, setProgress] = useState(false);
  const [companyList, setCompanyList] = useState<any>();
  const [listOfAccountjson, setListOfAccountjson] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [dtListOfContacts, setDtListOfContacts] = useState<any>();
  const [parentAccountName, setParentAccountName] = useState<any>();
  const { t } = useTranslation();

  const fetchdata = async () =>{
    let payload = {
          "tabid": "administration",
          "lcid": "1033",
          "datalang": "en-US"
      }
    
    try {
      setProgress(true)
      let pageLoad = await apiPost(POST_PROFILE_PAGE_LOAD,payload);
      if(pageLoad.data){
        let data = pageLoad.data;
        let CompanyList = allOptionForDropdown(JSON.parse(data?.CompanyList))
        setCompanyList([{ label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "" },...CompanyList])
        setListOfAccountjson(JSON.parse(data?.ListOfAccountjson))
        setUserData(JSON.parse(data?.UserData))
        setDtListOfContacts(JSON.parse(data?.dtListOfContacts))
        setParentAccountName(data?.ParentAccountName)
        setProgress(false)
      }else{
        toast.error(pageLoad?.Message);
        setProgress(false);
      }
    } catch (error) {
      setProgress(false)
    }
  }

  useEffect(() => {
    fetchdata();
  }, [])
  

  return (
    <div className="administration">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
        <Container>
        
            <AddNewContact
              companyList ={companyList?companyList:[]}
              title =" "
              parentCompany ={listOfAccountjson?listOfAccountjson?.[0] :[]}
              module ="addminitrator"
              btnName={t("HPI.btnadduser",{defaultValue:'Add User'})}
              fetchdata={fetchdata}
            />
            <AccountUser tabledata={dtListOfContacts} fetchdata={fetchdata} />
        </Container>
    </div>
  );
};
